import { UserInfo } from '@Entities/user/user'
import { EvaluationContext } from '@openfeature/core'

// this function is used for OpenFeature and should not break, so it handles an optional UserInfo even though UserInfo should always be present before context is sent to OpenFeature
const openFeatureUserContext = (userInfo?: UserInfo): EvaluationContext => {
    const environment = window.APP_CONFIG.MLC_ENV || 'local'
    if (!userInfo) {
        return {
            kind: 'environment',
            key: environment,
            environment: environment,
        }
    } else {
        return {
            kind: 'user',
            key: userInfo.exposedId || '',
            email: userInfo.email,
            firstName: userInfo.firstName,
            lastName: userInfo.lastName,
            groups: getGroups(userInfo),
            environment: environment,
        }
    }
}

const getGroups = (userInfo: UserInfo): string[] => {
    let groups = [userInfo.isInternal ? 'internal' : 'user']
    if (userInfo.groups) {
        groups = [...groups, ...userInfo.groups.map((group) => group.name)]
    }
    if (userInfo.permissions) {
        groups = [...groups, ...userInfo.permissions.map((permission) => permission.name)]
    }
    return groups
}

export default openFeatureUserContext
